export default __webpack_public_path__ + "static/team-5-f2fb7164e246455bd5d9f4d8babb1066.png";